import { APIConfiguration } from '../utils/environment';
import { AdminApi, SigmaApi } from './generated';

export const SigmaAPI = new SigmaApi(APIConfiguration);
export const AdminAPI = new AdminApi(APIConfiguration);
